import { Controller } from "@hotwired/stimulus"

// Manages the chat message composer textarea:
//   - Enter submits the form; Shift+Enter inserts a newline
//   - Auto-resizes the textarea as content grows
//   - Disables the submit button while the assistant is streaming
//   - Re-enables when the assistant message status transitions to done/failed
//     (detected via a MutationObserver on the messages container)
export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.autoResize()
    this.observeMessages()
  }

  disconnect() {
    if (this._observer) {
      this._observer.disconnect()
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (!this.submitTarget.disabled && this.inputTarget.value.trim()) {
        this.element.requestSubmit()
      }
    }
  }

  autoResize() {
    const el = this.inputTarget
    el.style.height = "auto"
    el.style.height = `${Math.min(el.scrollHeight, 160)}px`
  }

  onSubmitEnd(event) {
    if (event.detail.success) {
      this.inputTarget.value = ""
      this.autoResize()
      this.setDisabled(true)
    }
  }

  setDisabled(disabled) {
    this.submitTarget.disabled = disabled
  }

  observeMessages() {
    // Watch the messages container for DOM changes. When a pending/streaming
    // assistant message transitions to done/failed, re-enable the composer.
    const container = document.querySelector("[data-controller='chat-scroller']")
    if (!container) return

    this._observer = new MutationObserver(() => {
      const streaming = container.querySelector("[data-message-status='streaming'], [data-message-status='pending']")
      if (!streaming) {
        this.setDisabled(false)
      }
    })
    this._observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-message-status"]
    })
  }
}
